export enum MoodEnum {
    AUTHENTIC = "authentic",
    BUSINESS = "business",
    COMFORT = "comfort",
    ENERGETIC = "energetic"
}

export enum MoodNumericType {
    COMFORT = 0,
    BUSINESS = 1,
    AUTHENTIC = 2
}

export enum StockEnum {
    EXPERIENCE = "experience",
    STAY = "stay",
    HOLIDAY_PACKAGE = "holidayPackage",
    EVENT = "event"
}

export enum StockNumericType {
    EXPERIENCE = 0,
    STAY = 1,
    HOLIDAY_PACKAGE = 2,
    EVENT = 3
}

export enum PropertyTypeEnum {
    APARTMENT = "apartment",
    HOUSE = "house",
    VILLA = "villa",
    CABIN = "cabin",
    COTTAGE = "cottage",
    BUNGALOW = "bungalow",
}

export enum ExperienceTypeEnum {
    TOUR = "tour",
    ACTIVITY = "activity",
    WORKSHOP = "workshop",
    CLASS = "class",
    SHOW = "show",
    CONCERT = "concert",
}

export enum HolidayPackageTypeEnum {
    ALL_INCLUSIVE = "all_inclusive",
    ADVENTURE = "adventure",
    FAMILY = "family",
    ROMANTIC = "romantic",
    LUXURY = "luxury",
    BUDGET = "budget",
}

export enum HolidayPackageBookingTypeEnum {
    DEFINED_GUESTS = "defined_guests",
    SHARING_GROUP = "sharing_group",
    ORGANIZED_GROUP = "organized_group",
    ORGANIZED_PRIVACY = "organized_privacy",
}